import React from "react";
import { Link } from "react-router-dom";
export default function PrimaryBtn({ text, href, onClick , showIcon = true }) {
  return (
    <Link to={href || "#"} onClick={onClick} className="btn btn-primary" >
      {text}  {showIcon && <i className="fas fa-long-arrow-right"></i>}
    </Link>
  );
}